<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" v-loading="loading" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="入库时间" prop="inboundTime">
              <el-date-picker v-model="formData.inboundTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择入库时间" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productId">
              <el-select v-model="formData.productId" filterable clearable placeholder="请选择产品名称"
                @change="handleProductChange">
                <el-option v-for="item of productList" :key="item.productId" :label="item.productName"
                  :value="item.productId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品规格">
              <el-input v-model="productSpecName" disabled placeholder="选择产品后自动显示" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期或批号" prop="productionDateOrBatch">
              <el-input v-model.trim="formData.productionDateOrBatch" placeholder="请输入生产日期或批号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保质期" prop="shelfLife">
              <el-input v-model.trim="formData.shelfLife" placeholder="请输入保质期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入库数量" prop="inboundQuantity">
              <el-input v-model.trim="formData.inboundQuantity" placeholder="请输入入库数量" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交货人" prop="deliveryUserId">
              <el-select v-model="formData.deliveryUserId" filterable clearable placeholder="请选择交货人">
                <el-option v-for="item of userList" :key="item.userId" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收货人" prop="receiveUserId">
              <el-select v-model="formData.receiveUserId" filterable clearable placeholder="请选择收货人">
                <el-option v-for="item of userList" :key="item.userId" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submitting" :disabled="loading || loadFailed" @click="submit" class="global-button">保存</el-button>
          <el-button v-if="loadFailed" @click="loadData" class="global-button">重新加载</el-button>
          <el-button :disabled="submitting" @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'FinishedGoodsInboundAdd',
  data() {
    const validateQuantity = (rule, value, callback) => {
      if (!/^\d+(\.\d+)?$/.test(value) || !Number.isFinite(Number(value)) || Number(value) <= 0) {
        callback(new Error('入库数量必须为大于0的数字'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      loadFailed: false,
      submitting: false,
      productList: [],
      userList: [],
      productSpecName: '',
      formData: {
        inboundId: '', // 成品入库ID
        inboundTime: '', // 入库时间
        productId: '', // 产品名称
        productionDateOrBatch: '', // 生产日期或批号
        shelfLife: '', // 保质期
        inboundQuantity: '', // 入库数量
        deliveryUserId: '', // 交货人
        receiveUserId: '' // 收货人
      },
      rules: {
        inboundTime: [{ required: true, message: '请选择入库时间', trigger: 'change' }],
        productId: [{ required: true, message: '请选择产品名称', trigger: 'change' }],
        inboundQuantity: [{ required: true, validator: validateQuantity, trigger: 'blur' }],
        deliveryUserId: [{ required: true, message: '请选择交货人', trigger: 'change' }],
        receiveUserId: [{ required: true, message: '请选择收货人', trigger: 'change' }]
      }
    }
  },
  computed: {
    inboundId() {
      return this.$route.query.inboundId
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.loadFailed = false
      const requests = [this.loadProductList(), this.loadUserList()]
      if (this.inboundId) {
        requests.push(this.loadDetails())
      }
      return Promise.all(requests).catch(() => {
        this.loadFailed = true
      }).finally(() => {
        this.loading = false
      })
    },
    loadProductList() {
      return this.$axios.get(this.$apis.prodManage.selectScProductByPage).then(res => {
        this.productList = res.list
      })
    },
    loadUserList() {
      return this.$axios.get(this.$apis.system.selectSysUserByPage).then(res => {
        this.userList = res.list
      })
    },
    handleProductChange(productId) {
      const product = this.productList.find(item => item.productId === productId)
      this.productSpecName = product ? product.specName : ''
    },
    loadDetails() {
      return this.$axios.get(this.$apis.prodManage.selectScFinishedGoodsInboundById, {
        params: { inboundId: this.inboundId }
      }).then(res => {
        Object.keys(this.formData).forEach(key => {
          this.formData[key] = res[key] == null ? '' : res[key]
        })
        this.formData.inboundTime = res.inboundTime ? dayjs(res.inboundTime).format('YYYY-MM-DD HH:mm:ss') : ''
        this.productSpecName = res.productSpecName || ''
      })
    },
    submit() {
      if (this.loading || this.loadFailed || this.submitting) {
        return
      }
      this.$refs.formData.validate(valid => {
        if (!valid || this.submitting) {
          return
        }
        this.submitting = true
        let url = this.$apis.prodManage.insertScFinishedGoodsInbound
        if (this.inboundId) {
          url = this.$apis.prodManage.updateScFinishedGoodsInbound
        }
        this.$axios.post(url, {
          ...this.formData,
          inboundId: this.inboundId
        }).then(() => {
          this.$router.back()
        }).catch(() => {
          // 请求错误由全局拦截器提示，保留表单供修改后重试。
        }).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select,
.el-input,
.el-date-editor,
.el-textarea {
  width: 95%;
}
</style>
